import AccountPageTemplate from 'components/shared/AccountPageTemplate'

import { FormattedMessage } from 'react-intl'

const ActivationLinkExpired = () => (
    <AccountPageTemplate
        title={
            <FormattedMessage
                id="global.activation_link_expired_header"
                defaultMessage="Ups! Link aktywacyjny wygasł"
            />
        }
        text={
            <FormattedMessage
                id="global.activation_link_expired_description"
                defaultMessage="Twój link aktywacyjny wygasł. Aby utworzyć konto, wypełnij ponownie formularz rejestracji."
            />
        }
        hasLoginInfoHidden
        hasRegistrationButton
    />
)

export default ActivationLinkExpired
